import { Box, Theme } from "@outschool/backpack";
import { TrackedButton } from "@outschool/ui-components-shared";
import React from "react";

export function CircularShareButton({
  icon,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof TrackedButton> & {
  children: React.ReactNode;
  icon: React.ReactNode;
}) {
  return (
    <TrackedButton
      {...props}
      variant="link"
      sx={(theme: $TSFixMe) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        fontSize: theme.spacing(14),
        gap: "2px",

        "&:focus-visible": {
          outline: `2px solid ${theme.palette.primary.dark}`,
        },

        "&:hover": {
          textDecoration: "none",
        },
      })}
    >
      <Box
        sx={(theme: Theme) => ({
          display: "flex",
          width: "56px",
          height: "56px",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: theme.palette.primary[50],
          borderRadius: "50%",
          fontSize: "18px",
          color: theme.palette.primary[600],
          "&:hover": {
            backgroundColor: theme.palette.primary[200],
          },
          "&:active": {
            backgroundColor: theme.palette.primary[100],
          },
        })}
      >
        {icon}
      </Box>

      {children}
    </TrackedButton>
  );
}
